import { Icon } from "semantic-ui-react";

import "components/QuestionStatusIcon/QuestionStatusIcon.scss";
import { QUESTION_RESULT_STATUSES } from "models";

type QuestionStatusIconProps = {
  status?: QUESTION_RESULT_STATUSES | null;
};

type QuestionStatusIconConfig = {
  icon: string;
  color: string;
};

const QuestionStatusIconMap = new Map<QUESTION_RESULT_STATUSES, QuestionStatusIconConfig>([
  [QUESTION_RESULT_STATUSES.OK, { icon: "file", color: "#21BA45" }],
  [QUESTION_RESULT_STATUSES.OKWithRemarks, { icon: "file", color: "#21BA45" }],
  [QUESTION_RESULT_STATUSES.Advice, { icon: "triangle exclamation", color: "#FFBA39" }],
  [QUESTION_RESULT_STATUSES.Necessary, { icon: "circle exclamation", color: "#FF0202" }]
]);

export const QuestionStatusIcon = ({ status }: QuestionStatusIconProps) => {
  if (status === null || status === undefined) return <div />;

  const questionStatusIcon = QuestionStatusIconMap.get(status);
  if (!questionStatusIcon) return <div />;

  return (
    <div className="question-status-card-user">
      <div className={`${questionStatusIcon.icon === "file" && "question-status-card-icon-ok-container"}`}>
        <Icon
          className={`${questionStatusIcon.icon} question-status-card-icon ${questionStatusIcon.icon === "file" && "question-status-card-icon-ok"}`}
          style={{ color: questionStatusIcon.color, fontSize: "1rem" }}
        />
      </div>
    </div>
  );
};
